import React, { useEffect, useState } from 'react';
import {
  Alert,
  Box,
  CircularProgress,
  Grid,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { attendanceAPI } from '../../services/api';

const currentMonth = () => new Date().toISOString().slice(0, 7);

const StudentAttendance = () => {
  const [month, setMonth] = useState(currentMonth());
  const [records, setRecords] = useState([]);
  const [statistics, setStatistics] = useState({ total_days: 0, present: 0, absent: 0, percentage: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadAttendance = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await attendanceAPI.getAttendance({ month });
        setRecords(Array.isArray(response.data.records) ? response.data.records : []);
        setStatistics(response.data.statistics || { total_days: 0, present: 0, absent: 0, percentage: 0 });
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load attendance');
      } finally {
        setLoading(false);
      }
    };

    loadAttendance();
  }, [month]);

  return (
    <Box>
      <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="space-between" spacing={2} sx={{ mb: 3 }}>
        <Typography variant="h5" fontWeight="bold">My Attendance</Typography>
        <TextField
          label="Month"
          type="month"
          value={month}
          onChange={(event) => setMonth(event.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{ minWidth: 220 }}
        />
      </Stack>

      {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}

      <Grid container spacing={3} sx={{ mb: 3 }}>
        {[
          ['Present', statistics.present],
          ['Absent', statistics.absent],
          ['Attendance', `${statistics.percentage || 0}%`],
        ].map(([label, value]) => (
          <Grid item xs={12} sm={4} key={label}>
            <Paper sx={{ p: 3 }}>
              <Typography variant="caption" color="text.secondary">{label}</Typography>
              <Typography variant="h5" fontWeight="bold">{value}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 3 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}><CircularProgress /></Box>
        ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Date</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Remarks</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {records.length > 0 ? records.map((record) => (
                  <TableRow key={record.id} hover>
                    <TableCell>{new Date(record.attendance_date).toLocaleDateString()}</TableCell>
                    <TableCell>{record.status}</TableCell>
                    <TableCell>{record.remarks || '-'}</TableCell>
                  </TableRow>
                )) : (
                  <TableRow>
                    <TableCell colSpan={3} align="center">No attendance records found.</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Paper>
    </Box>
  );
};

export default StudentAttendance;
